import React from 'react'
import { SectionHeader } from '../schedule/SectionHeader'
import { DateMatches } from './MatchLevelPlayoffDateSchedule'

export const SectionSchedule = ({
  levelKey,
  matchDisplayType,
  matches_sections,
  matchScheduleDisplayType,
  sectionKey,
  team_fav_keys,
  teamKey,
}) => {

  const sectionHeader = <SectionHeader sectionKey={sectionKey} levelKey={levelKey} />

  const matches_section = !_.isEmpty(matches_sections) ? <DateMatches
    matches={matches_sections}
    teamKey={teamKey}
    matchDisplayType={matchDisplayType}
    matchScheduleDisplayType={matchScheduleDisplayType}
    team_fav_keys={team_fav_keys}
  /> : <div>No Matches</div>

  const div_section = <div className='match-date-matches'>
    <div>
      {sectionHeader}
      {matches_section}
    </div>
  </div>

  return div_section

}
